/**
 * design_handoff_accept_invitation §4 — screen 8 (Invitation no longer
 * valid). The backend can only tell "expired" apart from everything else
 * (already accepted / declined / withdrawn all 404 the same way once the
 * link stops resolving to a row — see CheckInvitationForm), so those three
 * share one generic, never-blame-the-user variant instead of the full
 * 4-row table in the handoff. Never "invalid token", never "something went
 * wrong".
 *
 * @param {'expired'|'generic'} cause
 * @param {{name: string}=} organization - only available when cause is 'expired'
 * @param {string=} inviterName
 * @param {function} onLogIn
 */
import React from "react";
import AuthStateCard from "../AuthPages/AuthStateCard";
import { Button } from "../../theme/untitled";

// Must match CheckInvitationForm::INVITATION_EXPIRY_DAYS on the backend.
const INVITATION_EXPIRY_DAYS = 7;

const InvalidInvitationScreen = ({
  cause,
  organization,
  inviterName,
  onLogIn,
}) => {
  const title =
    cause === "expired"
      ? "This invitation has expired"
      : "This invitation is no longer valid";

  const body =
    cause === "expired" ? (
      <p>
        Invitations last {INVITATION_EXPIRY_DAYS} days. Ask{" "}
        {inviterName || "whoever invited you"} to send you a new one from{" "}
        {organization?.name}'s Members page.
      </p>
    ) : (
      <p>
        It may have already been used, or the person who sent it may have
        withdrawn it. Ask them to send a new one.
      </p>
    );

  return (
    <AuthStateCard
      tone="neutral"
      icon="AlertCircle"
      title={title}
      actions={<Button onClick={onLogIn}>Log in</Button>}
    >
      {body}
    </AuthStateCard>
  );
};

export default InvalidInvitationScreen;
